interface QueryParams {
    [key: string]: any;
}

// Using ancient ES syntax on purpose to guarantee it works for all browsers
const buildQueryString = (params?: QueryParams): string => {
    if (params === undefined || params === null) {
        return '';
    }
    const validParams: QueryParams = {};
    let hasValidKeys = false;
    for (const key in params) {
        // Filters out undefined keys
        if (params.hasOwnProperty(key)) {
            const value = params[key];
            if (value !== undefined && value !== null && value !== '') {
                validParams[key] = value;
                hasValidKeys = true;
            }
        }
    }
    if (!hasValidKeys) {
        return '';
    }

    const URLParams = new URLSearchParams(validParams);
    return '?' + URLParams.toString();
};

export { buildQueryString };
